export default __webpack_public_path__ + "static/media/06_photo.f8c04cf1.jpg";